<i18n>
{
  "de": {
    "find_out_more_about_wifi_in_your_dorm": "Weitere Informationen zur WLAN-Verfügbarkeit",
    "tenant_portal_info": "Zugang zum Mieterportal für Mietvertragsbezogene Daten und Anfragen"
  },
  "en": {
    "find_out_more_about_wifi_in_your_dorm": "Further informations regarding Wi-Fi availability",
    "tenant_portal_info": "Access to the tenant portal for information and inquiries regarding your rental contract."
  }
}
</i18n>
<template>
  <div class="account">
    <h1>{{ $t('system.account') }}</h1>
    <Loading :data="[user]">
      <div v-if="user != null">
        <b-card :title="$tc('system.profile')">
          <b-form @submit="change_email">
            <b-card-text>
              <b-form-group label-for="profile_username" :label="$t('system.username')">
                <b-form-input id="profile_username" disabled :value="user.username"></b-form-input>
              </b-form-group>
              <b-form-group v-if="user.bewohner" label-for="profile_lastname" :label="$t('system.lastname')"
                            :description="$t('system.provided_by_stuwe')">
                <b-form-input id="profile_lastname" disabled
                              :value="user.bewohner.lastname"></b-form-input>
              </b-form-group>
              <b-form-group v-if="user.bewohner" label-for="profile_firstname" :label="$t('system.firstname')"
                            :description="$t('system.provided_by_stuwe')">
                <b-form-input id="profile_firstname" disabled
                              :value="user.bewohner.firstname"></b-form-input>
              </b-form-group>
              <b-form-group v-if="user.bewohner" label-for="profile_dorm" :label="$t('system.dorm')"
                            :description="$t('system.provided_by_stuwe')">
                <b-form-input id="profile_dorm" disabled
                              :value="user.bewohner.zimmer.hausnummer.wohnheim.wohnheim"></b-form-input>
              </b-form-group>
              <b-form-group v-if="user.bewohner" label-for="profile_house" :label="$t('system.house')"
                            :description="$t('system.provided_by_stuwe')">
                <b-form-input id="profile_house" disabled
                              :value="user.bewohner.zimmer.hausnummer.bezeichnung + ' ('+user.bewohner.zimmer.hausnummer.hausnummer + ')'"></b-form-input>
              </b-form-group>
              <b-form-group v-if="user.bewohner" label-for="profile_room" :label="$t('system.room')"
                            :description="$t('system.provided_by_stuwe')">
                <b-form-input id="profile_room" disabled
                              :value="user.bewohner.zimmer.zimmer"></b-form-input>
              </b-form-group>
              <b-form-group label-for="profile_email" :label="$t('system.email')">
                <b-form-input id="profile_email" v-model="user.email"></b-form-input>
              </b-form-group>
            </b-card-text>
            <label>
              <b-link id="tfa" href="https://idp.sw.whka.de/auth/realms/master/account/totp">{{
                  $t('system.manage_2fa')
                }}
              </b-link>
            </label>
            <br/>
            <label>
              <a href="https://www.sw-ka.de/de/wohnen/mieterportal/" target="_blank">{{ $t('tenant_portal_info') }}</a>
            </label>
            <br/>
            <b-button type="submit" variant="primary">{{ $t('system.save') }}</b-button>
          </b-form>
        </b-card>
        <b-card style="margin-top: 25px"
                :title="$t('system.change_password')">
          <b-form @submit="change_password">
            <b-card-text>
              <b-form-group label-for="profile_oldpw" :label="$t('system.old_password')">
                <b-form-input type="password" id="profile_oldpw" v-model="old_password"></b-form-input>
              </b-form-group>
              <b-form-group label-for="profile_newpw1" :label="$t('system.new_password')">
                <b-form-input type="password" id="profile_newpw1" v-model="new_password"></b-form-input>
              </b-form-group>
              <b-form-group label-for="profile_newpw2" :label="$t('system.confirm_password')">
                <b-form-input type="password" id="profile_newpw2" v-model="new_password2"
                              aria-describedby="wifi_pw_feedback"
                              :state="pw_send_error == null && new_password == new_password2 && new_password != ''"></b-form-input>
                <b-form-invalid-feedback id="pw_feedback">
                  <template v-if="pw_send_error == null">
                    {{ $t('errors.password_must_match') }}
                  </template>
                  <template v-else>{{ $t('errors.' + pw_send_error) }}
                  </template>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-card-text>
            <b-button type="submit" variant="primary">{{ $t('system.change_password') }}</b-button>
          </b-form>
        </b-card>
        <b-card id="profile_wifi" style="margin-top: 25px" v-if="wifi_username"
                :title="$t('system.wifi_password')">
          <b-form @submit="change_wifi_password">
            <b-card-text>
              <p>
                <b-link to="/wifi">{{ $t('find_out_more_about_wifi_in_your_dorm') }}</b-link>
              <p/>
              <b-form-group label-for="profile_wifi_username" :label="$t('system.username')">
                <b-form-input :value="wifi_username" id="profile_wifi_username" disabled></b-form-input>
              </b-form-group>
              <b-form-group label-for="profile_wifi_newpw1" :label="$t('system.new_password')">
                <b-form-input type="password" v-model="new_wifi_password"
                              id="profile_wifi_newpw1"></b-form-input>
              </b-form-group>
              <b-form-group label-for="profile_wifi_newpw2" :label="$t('system.confirm_password')">
                <b-form-input type="password" v-model="new_wifi_password2"
                              aria-describedby="wifi_pw_feedback"
                              :state="wifi_pw_send_error == null && new_wifi_password == new_wifi_password2 && new_wifi_password != ''"
                              id="profile_wifi_newpw2"></b-form-input>
                <b-form-invalid-feedback id="wifi_pw_feedback">
                  {{ $t('errors.password_must_match') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-card-text>
            <b-button type="submit" variant="primary">{{ $t('system.change_password') }}</b-button>
          </b-form>
        </b-card>
      </div>
    </Loading>
  </div>
</template>

<script>
import AccountService from '@/api-services/account.service'
import Loading from "../../components/Loading";
import {EventBus} from '@/eventbus';

export default {
  name: 'sw_ka_account',
  components: {Loading},
  data() {
    return {
      user: null,
      old_password: null,
      new_wifi_password: null,
      new_wifi_password2: null,
      new_password: null,
      new_password2: null,
      pw_send_error: null,
      wifi_pw_send_error: null,
      wifi_username: null
    }
  },
  async mounted() {
    let resp = await AccountService.get_current_user()
    this.user = resp.data.user
    this.wifi_username = this.user.bewohner.zimmer.hausnummer.hausnummer + '_' + this.user.bewohner.zimmer.zimmer.replace(' ', '')
    setTimeout(() => this.scrollFix(this.$route.hash), 1);
  },
  methods: {
    async change_email(ev) {
      ev.preventDefault()
      AccountService.change_email(this.user.email)
      this.$emit('alert', {
        variant: 'warning',
        message: "We've send an email to '" + this.user.email + "' in order to verify the address. Please check your inbox. The address will be updated, if the verification succeeds."
      })
      EventBus.$emit('alert', {
        variant: 'warning',
        message: "We've send an email to '" + this.user.email + "' in order to verify the address. Please check your inbox. The address will be updated, if the verification succeeds."
      })
    },
    async change_wifi_password(ev) {
      ev.preventDefault()
      if (this.new_wifi_password == this.new_wifi_password2) {
        try {
          await AccountService.change_wifi_password(this.new_wifi_password)
          this.$emit('alert', {
            variant: 'success',
            message: "messages.password_updated"
          })
          EventBus.$emit('alert', {
            variant: 'success',
            message: "messages.password_updated"
          })
          this.wifi_pw_send_error = null
          this.new_wifi_password = this.new_wifi_password2 = null

        } catch (e) {
          this.wifi_pw_send_error = e.response.data.error
        }
      }
    },
    async change_password(ev) {
      ev.preventDefault()
      if (this.password == this.password2) {
        try {
          await AccountService.change_password(this.old_password, this.new_password)
          this.$emit('alert', {
            variant: 'success',
            message: "messages.password_updated"
          })
          EventBus.$emit('alert', {
            variant: 'success',
            message: "messages.password_updated"
          })
          this.pw_send_error = null
          this.new_password = this.new_password2 = this.old_password = null

        } catch (e) {
          this.pw_send_error = e.response.data.error
        }
      }
    },
    scrollFix: function (hashbang) {
      location.hash = hashbang
    }
  }
}
</script>
